<div
  class="rounded-xl border border-neutral-border dark:border-dark-border bg-neutral-soft dark:bg-dark-tertiary px-3 py-2.5 space-y-2">
  <div class="flex items-center gap-3">
    <span
      class="w-7 h-7 rounded-lg bg-gray-200 dark:bg-dark-secondary flex items-center justify-center shrink-0">
      <span class="material-symbols-rounded text-base text-gray-500 dark:text-dark-muted">label</span>
    </span>
    <span class="flex-1 text-[13px] font-semibold text-gray-900 dark:text-dark-text">{{ TEXT.TRANSACTIONS.TAGS
      }}</span>
    <button type="button" (click)="remove.emit()"
      class="w-7 h-7 rounded-full hover:bg-white dark:hover:bg-dark-secondary text-gray-400 inline-flex items-center justify-center shrink-0 transition-colors">
      <span class="material-symbols-rounded text-base">close</span>
    </button>
  </div>
  <div *ngIf="tags.length > 0" class="flex flex-wrap gap-1.5">
    <span *ngFor="let tag of tags; let i = index"
      class="inline-flex items-center px-2 py-0.5 rounded-full border text-xs" [ngClass]="tagColor(tag)">
      {{ tag }}
      <button type="button" (click)="removeTag(i)" class="ml-1 opacity-60 hover:opacity-100">
        <span class="material-symbols-rounded text-xs">close</span>
      </button>
    </span>
  </div>
  <div class="relative">
    <input type="text" [(ngModel)]="tagInput"
      class="w-full h-10 px-3.5 border border-neutral-border dark:border-dark-border rounded-xl bg-white dark:bg-dark-secondary text-sm text-gray-900 dark:text-dark-text placeholder:text-gray-400 dark:placeholder:text-dark-muted outline-none focus:ring-2 focus:ring-brand-primary/40 transition-shadow"
      [placeholder]="TEXT.TRANSACTIONS.ADD_TAGS"
      (keydown)="handleTagInputKeydown($event)"
      (input)="onTagInputChange()"
      (focus)="onTagInputChange()"
      (blur)="hideTagSuggestions()" />
    <div *ngIf="suggestionsMode === 'dropdown' && showTagSuggestions && filteredTagSuggestions.length > 0"
      class="absolute z-10 mt-1 w-full bg-white dark:bg-dark-secondary border border-neutral-border dark:border-dark-border rounded-xl shadow-lg max-h-32 overflow-y-auto">
      <button *ngFor="let suggestion of filteredTagSuggestions" type="button"
        (mousedown)="selectTagSuggestion(suggestion)"
        class="w-full text-left px-3.5 py-1.5 text-sm text-gray-700 dark:text-dark-text hover:bg-neutral-soft dark:hover:bg-dark-tertiary transition-colors">
        {{ suggestion }}
      </button>
    </div>

    <div *ngIf="suggestionsMode === 'inline' && inlineSuggestions.length > 0" class="flex flex-wrap gap-1.5 mt-2">
      <button *ngFor="let suggestion of inlineSuggestions" type="button"
        (click)="selectTagSuggestion(suggestion)"
        class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-xs opacity-80 hover:opacity-100 transition-opacity"
        [ngClass]="tagColor(suggestion)">
        <span class="material-symbols-rounded text-[13px]">add</span>{{ suggestion }}
      </button>
    </div>
  </div>
</div>
